export default function HyphenBox() {
  return (
    <div className="flex h-4 w-4 items-center justify-center bg-primary-500">
      <div className="h-1 w-2 bg-white " />
    </div>
  );
}
